// extracted by mini-css-extract-plugin
export var text = "_5g-0";